module.exports = "iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAlUlEQVQ4y2NgGBTATbvm/14Rw//nBNVIwggTLFb8FzSd+79X1p98A2A4pOro/1fvf/wnBmA1AIRFPdb/X3fgMekGgGxHNshFuxZv2KAYUDr5AtjU8JpjKIYoGU3+X6IUT9gA3ejt/z0KDv6X898E1+yoU0+8C9DDYMXuh+QFYmD5EfJiAZQOOuSCyEsHhPxKOAyGNAAAjPaAXTha2PoAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./~/base64-loader!./client/components/FlagControl/png/16/PR.png
// module id = 1244
// module chunks = 0